export default __webpack_public_path__ + "static/media/tvss.94dca681.png";